// extracted by mini-css-extract-plugin
export default {"filterSection":"filter_filterSection__PFkra","filterGroup":"filter_filterGroup__m3Wqq"};